// extracted by mini-css-extract-plugin
export default {"grammarPanel":"GrammarPanel_grammarPanel__PgI6K","grammarPanel__mobile":"GrammarPanel_grammarPanel__mobile__1kjCU"};